module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af503237f250eaab70eec701bc0c88b9.png";